import { Component } from 'react';
import ACBadRequestError from './ACBadRequestError';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorCatcher extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    this.props.onError(error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
const ErrorBoundary = ({
  boundaryName,
  resetKeys,
  fallback,
  children
}) => {
  var _resetKeys$join;
  const resetKey = `${boundaryName !== null && boundaryName !== void 0 ? boundaryName : ''}-${(_resetKeys$join = resetKeys === null || resetKeys === void 0 ? void 0 : resetKeys.join(',')) !== null && _resetKeys$join !== void 0 ? _resetKeys$join : ''}`;
  const handleError = (error, errorInfo) => {
    Raven.captureException(error, Object.assign({
      extra: errorInfo
    }, boundaryName && {
      tags: {
        boundaryName
      }
    }));
  };
  return /*#__PURE__*/_jsx(ErrorCatcher, {
    fallback: fallback !== null && fallback !== void 0 ? fallback : /*#__PURE__*/_jsx(ACBadRequestError, {}),
    onError: handleError,
    children: children
  }, resetKey);
};
export default ErrorBoundary;